import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import Loader from "../../components/common/Loader";
import dayjs from "dayjs";
import DeleteModal from "../../components/common/DeleteModal";
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import { Topbar } from "../../components/include/Topbar";
import { isPermission, isRole, isRoleType } from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";

const View_club = () => {
  const [data, setData] = useState({});
  const [openMenuIndex, setOpenMenuIndex] = useState(false);
  const [loader, setLoader] = useState(false);
  const menuRefs = useRef({});
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const [selectedImage, setSelectedImage] = useState("");
  const dispatch = useDispatch();
  const params = useParams();
  const [selectedId, setSelectedId] = useState(null);
  const [modalOpenDelete, setmodalOpenDelete] = useState(false);
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  console.log("permissions", permissions);
  const isAccessible =
    role === "admin" ||
    role === "subadmin" ||
    role === "schooladmin" ||
    (permissions && (permissions?.includes("view_Extracurricular") || permissions?.includes("view_School"))) ||
    false;
  const addPermission =
    role === "subadmin" ||
    role === "schooladmin" ||
    (permissions && (permissions?.includes("edit_Extracurricular") || permissions?.includes("edit_School"))) ||
    false;
  const deletePermission =
    role === "subadmin" ||
    role === "schooladmin" ||
    (permissions && (permissions?.includes("delete_Extracurricular") || permissions?.includes("delete_School"))) ||
    false;
  const schoolId = localStorage.getItem("activeSchoolId");
  const mode = localStorage.getItem("mode");
  const toggleMenu = (index) => {
    setOpenMenuIndex(!openMenuIndex);
    // setOpenMenuIndex(true);
  };
  const handleDelete = (id) => {
    setLoader(true);
    Postdata(HttpService.clubs_delete, { id: id, school_id: schoolId }).then(
      (res) => {
        if (res.status === 200) {
          if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
            if (mode === "view") {
              navigate(`admin-school/view/${schoolId}`, {
                state: { mainTab: "Extracurricular", currentTab: "Clubs" },
              });
            } else {
              navigate("navigation-dashboard", {
                replace: true,
                state: { mainTab: "Extracurricular", currentTab: "Clubs" },
              });
            }
          } else {
            navigate("extracurricular", {
              replace: true,
              state: { currentTab: "Clubs" },
            });
          }
        }
      }
    );
    setLoader(false);
  };

  const fetchData = () => {
    setLoader(true);
    Postdata(HttpService.clubs_show, {
      id: params.id,
      school_id: schoolId,
    }).then((res) => {
      if (res.status === 200) {
        setData(res.data);
        if (res.data.image) {
          setSelectedImage(res.data.image); // Set first image initially
        }
      } else {
        dispatch(message(res.message));
      }
    });
    setLoader(false);
  };

  useEffect(() => {
    fetchData();
  }, []);
  if (loader) {
    return <Loader isClass="loader_fullscreen" />;
  }
  if (!isAccessible) {
    return <Error403Page />;
  }
  return (
    <>
      <Topbar aerrow={true} currentTab={"Clubs"} />
      <div className="mx-auto p-4">
        {selectedImage && (
          <div className="mb-4">
            <img
              src={selectedImage}
              alt="Selected"
              className="w-full h-96 object-fill rounded-lg "
            />
          </div>
        )}
        <div className="bg-white rounded-xl p-4 relative flex justify-between text-gray-800   mx-auto">
          <div>
            <h3 className="text-md font-semibold mb-2">{data.title}</h3>
            <h3 className="text-sm text-gray-400 font-normal ">
              {dayjs(data.createdAt).format("DD MMM YYYY")}
            </h3>
            <h3 className="text-sm font-semibold mb-2">{data.brief}</h3>
            <h3 className="text-sm font-normal mb-2">{data.detailed}</h3>
          </div>
          {(addPermission || deletePermission) && (
            <div className="bg-white  ">
              <div className="absolute top-3 right-3">
                <button onClick={() => toggleMenu()}>
                  <img
                    src={HiOutlineDotsVertical}
                    className="text-black-500 hover:text-black"
                  />
                </button>

                {openMenuIndex && (
                  <div
                    ref={(el) => (menuRefs.current = el)}
                    className="absolute right-0 w-20 bg-white shadow-md border rounded-xl z-10"
                  >
                    {addPermission && (
                      <button
                        className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                        onClick={() =>
                          navigate(`extracurricular/clubs/edit/${data._id}`, {
                            state: { type: "edit" },
                          })
                        }
                      >
                        Edit
                      </button>
                    )}
                    {deletePermission && (
                      <button
                        onClick={() => {
                          setSelectedId(data._id);
                          setmodalOpenDelete(true);
                        }}
                        className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                      >
                        Delete
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <DeleteModal
          title="Delete Clubs "
          message="Are you sure you want to delete Clubs ?
It will erase all the data permanently."
          modalOpenDelete={modalOpenDelete}
          setmodalOpenDelete={setmodalOpenDelete}
          handleDelete={handleDelete} // Don't call it here
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          modalOpenDeleteSuccess={modalOpenDeleteSuccess}
          setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
          module={"Clubs"}
          redirectPage={"Clubs"}
          redirectUrl={
            mode === "view"
              ? `admin-school/view/${schoolId}`
              : role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin"
                ? "navigation-dashboard"
                : "extracurricular"
          }
          redirectState={
            (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") ? { mainTab: "Extracurricular", currentTab: "Clubs" } : undefined
          }
        />
      </div>
    </>
  );
};

export default View_club;
